import React from 'react';
import { Box, IconButton } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';
import { setShowSuccessPopUp } from '../../../redux/slices/sellerProfileSlice';
import { useSelector, useDispatch } from 'react-redux';

const SuccessPopUp = ({ topPx }) => {
  const dispatch = useDispatch();
  const { showSuccessPopUp, successType = 'success' } = useSelector((state: any) => state.sellerProfile);

  // Auto close after 4 seconds
  React.useEffect(() => {
    if (showSuccessPopUp) {
      const timer = setTimeout(() => {
        dispatch(setShowSuccessPopUp(''));
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessPopUp, dispatch]);

 const color = successType === 'error' ? '#B83A32' : '#224D22';
  const bgColor = successType === 'error' ? '#FFF1F0' : '#E8F5E9';
  const textColor = 'black';
  const Icon = successType === 'error' ? ErrorIcon : CheckCircleIcon;

  if (!showSuccessPopUp) return null;

  return (
    <div
      className="successCloseZone"
      onClick={() => dispatch(setShowSuccessPopUp(''))}
      style={{
        position: 'fixed',
        top: topPx || 0,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1300,
        cursor: 'pointer',
        width: '100%',
        maxWidth: '100vw',
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          bgcolor: bgColor,
          // color: '#fff',
          border: `0.5px solid ${color}`,
          borderRadius: '1rem',
          boxShadow: 2,
          // px: 3,
          py: 1,
          color: textColor,
          width: { xs: '90%', sm: 'fit-content' },
          // width: 'max-content',
          // maxWidth: 400,
          margin: '0 auto',
          fontWeight: 400,
          fontSize: '0,875rem',
          pointerEvents: 'auto', // allow the popup itself to be clickable
        }}
      >
        <Icon sx={{ mx: 1, color, fontSize: 22 }} />
        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{showSuccessPopUp}</span>
         <IconButton
          aria-label="close"
          onClick={() => dispatch(setShowSuccessPopUp(''))}
          sx={{ color: textColor, ml: 2, p: 0.5 }}
        >
          <CloseIcon sx={{color: 'black'}} />
        </IconButton>
      </Box>
    </div>
  );
};

export default SuccessPopUp;